<template>
  <Modal v-model="importCommodityInfoModal" :title="$t('key1000257')" :transfer="false" :mask-closable="false" width="600"
    @on-visible-change="importCommodityInfoChange">
    <Form ref="importCommodityInfo" :label-width="130" @submit.native.prevent>
      <Row type="flex">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" style="margin-bottom: 24px;">
          <h2 class="font-weight-bold">{{ $t('key1000263') }}</h2>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000258')" prop="ymsProductCategoryId" class="required_style_label">
            <classificationSelect class="width_350" ref="classificationDom" @selectValue="changeValue"></classificationSelect>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem prop="warehouseIds" :label="$t('key1000259')" class="required_style_label">
            <div class="flex align-items-center" v-if="isSelfOperated === 0">
              <Select v-model="warehouseIds" transfer filterable multiple class="width_350">
                <Option v-for="item in productShippingWarehouseData" :value="item.ymsWarehouseId" :label="item.name + ' (' + item.warehouseTypeName + ')'">
                  <div class="flex align-items-center justify-content-between" style="width: 95%;">
                    <span class="color-333">{{ item.name }}</span>
                    <span class="font-size-12 color-999">{{ item.warehouseTypeName }}</span>
                  </div>
                </Option>
              </Select>
              <Tooltip
                max-width="400" :transfer="true" placement="top"
                :content="$t('key1000260')">
                <Icon class="cursor ml5" size="24" color="#2D8CF0" type="ios-information-circle"/>
              </Tooltip>
            </div>
            <Select v-model="warehouseIds" class="width_350" transfer filterable multiple v-else>
              <Option v-for="item in ymsWarehouseList" :value="item.ymsWarehouseId" :key="item.ymsWarehouseId">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000261')">
            <Button type="text" @click="download" :disabled="!(ymsProductCategoryId && warehouseIds.length >0)"
              class="download_styles">{{ $t('key1000264') }}</Button>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" style="margin-bottom: 24px;">
          <h2 class="font-weight-bold">{{ $t('key1000265') }}</h2>
        </Col>
        <Col span="24" class="no_margin_style">
          <Form-item :label="$t('key1000262')" prop="file" class="required_style_label">
            <Upload
              style="display: inline-block"
              :headers="headObj"
              ref="uploadRef"
              name='files'
              :show-upload-list="false"
              :action="importInterface"
              :data="parameter"
              :before-upload="beforeHandleUpload"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :on-exceeded-size="uploadExceedSize"
              :on-format-error="handleFormatError"
              :max-size="uploadFilesMaxSize"
              :format="['zip']">
              <Button class="mr10">
                <i class="iconfont mr5">&#xe663;</i>
                {{ $t('key1000266') }}
              </Button>
            </Upload>
          </Form-item>
        </Col>
        <Col push="3" :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="excleFile">
          <h3 class="excleFile_title">{{ excleFile.name }}</h3>
        </Col>
        <Col push="3" :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <div class="flex align-items-center">
            <span>{{ $t('key1000267') }}</span>
            <RadioGroup v-model="updateIgnore">
              <Radio :label="0">{{ $t('key1000268') }}</Radio>
              <Radio :label="1">{{ $t('key1000269') }}</Radio>
            </RadioGroup>
          </div>
        </Col>
        <Col push="3" :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <div class="tips_styles">
            {{ $t('key1000270') }}<br/>
            {{ $t('key1000271') }}<br/>
            {{ $t('key1000272') }}<br/>
            {{ $t('key1000273') }}<br/>
            {{ $t('key1000274') }}<br/>
            {{ $t('key1000275') }}<br/>
          </div>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="importCommodityInfoModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="saveImport">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import classificationSelect from "@/components/common/classificationSelect.vue";
import {getBatchSupplierWarehouseData, getCloudTreeData} from "@/utils/common";

export default {
  name: "importCommodityInfoModal",
  mixins: [Mixin],
  props: {
    // 是否自营商品， 1 表示自营， 0 表示非自营
    isSelfOperated: {
      type: Number,
      default: 0
    },
    // 导入接口
    importInterface: {
      type: String,
      default: ''
    }
  },
  data() {
    let v = this;
    return {
      ymsProductCategoryId: null,
      importCommodityInfoModal: false,
      excleFile: null,
      updateIgnore: 0,
      parameter: {
        ymsProductCategoryId: v.ymsProductCategoryId,
        updateIgnore: v.updateIgnore,
        warehouseIds: []
      },
      warehouseIds: [],
      uploadFilesMaxSize: 102400, // 上传文件大小上线（kb）
      ymsProductCategoryList: [],
      productShippingWarehouseData: [],
      ymsWarehouseList: [],
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initImportCommodityInfoData() {
      this.getCloudSalesClassification();
      switch (this.isSelfOperated) {
        case 1:
          this.getDeliveryWarehousesData();
          break;
        case 0:
          getBatchSupplierWarehouseData([this.userInfo.merchantId]).then((newList) => {
            this.productShippingWarehouseData = this.uniqueFunc(newList, 'ymsWarehouseId');
          });
          break;
      }
      this.importCommodityInfoModal = true;
    },
    // 获取中心仓数据
    getDeliveryWarehousesData() {
      return new Promise((resolve) => {
        this.axios.get(api.get_ymsWarehouse_queryDeliveryWarehouseList).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            let newData = data.filter((item) => {
              return item.status === 1 && item.servicePlatform === 'core';
            });
            this.ymsWarehouseList = newData;
            resolve(newData);
          }
        });
      })
    },
    // 获取云卖分类的数据
    getCloudSalesClassification() {
      if (this.ymsProductCategoryList.length <= 0) {
        getCloudTreeData(api.post_ymsProductCategory_api_queryAll, 'tile').then((data) => {
          this.ymsProductCategoryList = data;
          this.$nextTick(() => {
            this.$refs['classificationDom'].initClassificationData(data);
          });
        });
      }
    },
    // 分类
    changeValue(value) {
      this.ymsProductCategoryId = value;
    },
    // 上传文件之前
    beforeHandleUpload(excleFile) {
      const maxSizeBytes = this.uploadFilesMaxSize * 1024; // KB 转 bytes
      if (excleFile.size > maxSizeBytes) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000249'));
        return false;
      }
      this.excleFile = excleFile;
      return false;
    },
    // 上传文件失败
    uploadError() {
      this.importCommodityInfoModal = false;
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000250'));
      return false;
    },
    // 控制上传图片大小
    uploadExceedSize() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000249'));
      return false;
    },
    // 上传文件成功
    uploadSuccess(res, file, fileList) {
      let v = this;
      if (res.code === 0) {
        v.importCommodityInfoModal = false;
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
        setTimeout(() => {
          v.$emit('updateData', true);
        }, 2000);
      }
    },
    // 关闭弹窗重置数据
    reset() {
      this.ymsProductCategoryId = null;
      this.excleFile = null;
      this.updateIgnore = 0;
      this.warehouseIds = [];
      this.productShippingWarehouseData = [];
    },
    // 导入的确定按钮
    saveImport() {
      let v = this;
      v.importCommodityInfoModal = true;
      if (!v.ymsProductCategoryId) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000252'));
        return false;
      }
      if (v.warehouseIds.length <= 0) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000253'));
        return false;
      }
      if (v.excleFile) {
        const maxSizeBytes = v.uploadFilesMaxSize * 1024;
        if (v.excleFile.size > maxSizeBytes) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000249'));
          return false;
        }
        v.parameter.ymsProductCategoryId = v.ymsProductCategoryId;
        v.parameter.updateIgnore = v.updateIgnore;
        v.parameter.warehouseIds = v.warehouseIds;
        v.$refs.uploadRef.post(this.excleFile); // 手动上传
        setTimeout(() => {
          v.excleFile = null;
          v.importCommodityInfoModal = false;
        }, 2000);
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000254'));
        return false;
      }
    },
    // 模板下载
    download() {
      let v = this;
      if (v.ymsProductCategoryId) {
        let url = v.isSelfOperated === 1 ? api.get_ymsProductInfoCore_getImportExcelTemplate : api.get_productInfo_getImportExcelTemplate;
        v.axios.get(url + v.ymsProductCategoryId + `?warehouseIds=${v.warehouseIds}`
          , {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000255')}).then((res) => {
          if (res.data.code === 0) {
            let url = res.data.datas;
            if (url) {
              window.open(url, '_self');
              setTimeout(() => {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000256'));
              }, 1500);
            }
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000252'));
        return false;
      }
    },

    // 监听弹窗
    importCommodityInfoChange(value) {
      if (!value) {
        this.reset();
        this.$refs['classificationDom'].reset();
      }
    }
  },
  components: {
    classificationSelect
  }
};
</script>

<style lang="less" scoped>
.excleFile_title {
  margin-bottom: 24px;
  font-weight: bold;
  color: #333;
}

.tips_styles {
  color: #9a9797;
  margin: 12px 0 20px 0;
}

.download_styles {
  color: #57a3f3;
  font-size: 13px;
  padding: 0;
  position: relative;
  top: -1px;
  border: none !important;
}

.ivu-btn-text:focus {
  box-shadow: initial !important;
}

.ivu-btn-text[disabled] {
  color: #c5c8ce !important;
}
</style>
